// 关联用户管理
import http from "@/jslibs/axios/http";

// 关联用户列表
export const list = ({ uuid, ...data }) => http.get(`/v1/cms/UserLabel/users/${uuid}`, data);

// 添加用户
export const add = ({ uuid, ...data }) => http.put(`/v1/cms/UserLabel/add_user/${uuid}`, data);

// 移除用户
export const del = ({ uuid, ...data }) => http.put(`/v1/cms/UserLabel/del_user/${uuid}`, data);

// 转移用户
export const transfer = (data) => http.post(`/v1/cms/UserLabel/transfer_user`, data);